import React, {createContext} from 'react';
import {AccessKeyService} from '../services/AccessKeyService';
import {AttributeService} from '../services/AttributeService';
import {AuthService} from '../services/AuthService';
import {ContactService} from '../services/Contact/ContactService';
import {FirebaseService} from '../services/FirebaseService';
import {InboxService} from '../services/Inbox/InboxService';
import {MaterialService} from '../services/MaterialService';
import {PackingListService} from '../services/PackingList/PackingListService';
import {PurchaseOrderService} from '../services/PurchaseOrder/PurchaseOrderService';
import {SalesOrderService} from '../services/SalesOrder/SalesOrderService';
import {ServiceProvider} from '../services/ServiceProvider';
import {SettingsService} from '../services/SettingsService';
import {UserService} from '../services/UserService';
import {TaskService} from '../services/Task/TaskService';

export const ServiceContext = createContext({});

export default function Services({children}) {
  const services = {
    attribute: {
      materialColour: new AttributeService('material-colours'),
      materialFormat: new AttributeService('material-formats')
    },
    accessKey: new AccessKeyService(),
    auth: new AuthService(),
    contact: new ContactService(),
    firebase: new FirebaseService(),
    inbox: new InboxService(),
    material: new MaterialService(),
    packingList: new PackingListService(),
    purchaseOrder: new PurchaseOrderService(),
    salesOrder: new SalesOrderService(),
    settings: new SettingsService(),
    task: new TaskService(),
    user: new UserService()
  };
  ServiceProvider.setServices(services);
  return (
    <ServiceContext.Provider value={services}>{children}</ServiceContext.Provider>
  );
}
